import api from '@/api'

// Actions（処理）
// https://next.vuex.vuejs.org/ja/guide/actions.html
// コンポーネントからミューテーションを実行する関数
const actions = {
  /**
   * データを追加または更新する
   *
   * @param {object}
   * @return {void}
   */
  async postOrPatch({ dispatch }, formData) {
    // 必要なデータのみにする
    const requiredKeys = ['id', 'inspection_type_id', 'inspection_id', 'code']
    const submitData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => requiredKeys.includes(key)),
    )

    try {
      let response
      if ('id' in submitData && submitData['id']) {
        response = await dispatch('patchData', submitData)
      } else {
        response = await dispatch('postData', submitData)
      }
      return response
    } catch (error) {
      console.error('Failed to post or patch data:', error)
      throw error
    }
  },
  /**
   * データを追加する
   *
   * @param {object}
   * @return {object}
   */
  async postData(_, formData) {
    try {
      const response = await api.post('manage/inspection_calls/', formData)
      return response.data
    } catch (error) {
      console.error('Failed to post data:', error)
      throw error
    }
  },
  /**
   * データを更新する
   *
   * @param {object}
   * @return {object}
   */
  async patchData(_, formData) {
    try {
      const response = await api.patch(
        'manage/inspection_calls/' + formData.id + '/',
        formData,
      )
      return response.data
    } catch (error) {
      console.error('Failed to patch data:', error)
      throw error
    }
  },
  /**
   * データを削除する
   *
   * @param {number}
   * @return {object}
   */
  async deleteData(_, id) {
    try {
      const response = await api.delete('manage/inspection_calls/' + id + '/')
      return response.data
    } catch (error) {
      console.error('Failed to delete data:', error)
      throw error
    }
  },
}

export default {
  namespaced: true,
  actions,
}
